/*
 * @Description: Google 和 FaceBook 按钮容器
 * @Author: kadenwang@tencent.com
 * @Date: 2021-11-18 10:37:35
 * @LastEditors: yanxia@tencent.com
 * @LastEditTime: 2022-05-07 14:14:10
 */

import { Market } from '@tencent/halo-jsbridge-syzs/dist/halo-jsbridge-syzs.cjs.js';
import { isAppMarket } from '@tencent/syzs-login-sdk-utils';
import classnames from 'classnames';
import { useCallback, useEffect } from 'react';
import { useForm, UseFormMethods } from 'react-hook-form';
import { CheckBox, FaceBookLoginButton, GoogleLoginButton, Toast } from '../../component';
import i18n from '../../i18n';
import { getClientType, isMobile, postMessageToParent } from '../../lib';
import './GoogleAndFaceBookButtons.less';

export const openUrl = (url: string) => {
  if (isAppMarket()) {
    Market.OpenUrlWithBrowser(url);

    return;
  }

  window.open(url, '_blank');
};

export interface ILink {
  url: string;
}


export const Link: React.FC<ILink> = (props: React.PropsWithChildren<ILink>) => {
  const { children, url } = props;

  return (
    <a className="login-link" onClick={() => openUrl(url)}>{ children }</a>
  );
};

export interface IAgreePolicy {
  register: UseFormMethods['register'];
  content?: React.ReactNode;
  name?: string;
  field: string;
  url?: string;
  error?: boolean;
  message?: string;
  messageAfter?: string;
}

export const AgreePolicy: React.FC<IAgreePolicy> = (props: IAgreePolicy) => {
  const { register, field, name, url, error, content, message = i18n.l('Agree'), messageAfter } = props;

  return (
    <div className="agree-items">
      <CheckBox
        name={field}
        register={register}
        label=""
        error={error}
      />
      <span className="msg">
        { content }
        { !content && message}
        { !content && url && <Link url={url}>{ name }</Link>}
        { !content && messageAfter}
      </span>
    </div>
  );
};

export const GoogleAndFaceBookButtons = () => {
  const { register, watch, trigger } = useForm();
  const watchAllFields = watch();
  const { agreeTerms, agreePrivacy } = watchAllFields;

  const checkUserIsAgree = useCallback(
    () => {
      if (isMobile()) return;

      if (agreeTerms && agreePrivacy) return;

      window.aegis.infoAll(`PleaseAgreeTerms agreePrivacy ${agreePrivacy} agreeTerms ${agreeTerms}`);
      Toast.error(i18n.l('PleaseAgreeTerms'));
    },
    [agreeTerms, agreePrivacy],
  );

  useEffect(() => {
    void trigger();
  }, [trigger]);

  const canLogin = isMobile() || (agreeTerms && agreePrivacy);

  return (
    <div className="login-v2-buttons-container">
      { isMobile() && (
        <div
          className="back-icon"
          onClick={() => {
            void postMessageToParent('CLOSE_LOGIN_MODAL', {});
          }}
        />
      ) }
      <div className="logo" />
      <p className="log-in">Log In</p>
      <div onClick={checkUserIsAgree}>
        <div className={classnames(['login-button', 'facebook'], { canNotLogin: !canLogin })}>
          <FaceBookLoginButton />
        </div>
      </div>
      <div onClick={checkUserIsAgree}>
        <div className={classnames(['login-button', 'google'], { canNotLogin: !canLogin })}>
          <GoogleLoginButton />
        </div>
      </div>
      <div className="show-confirm">
        <form className="checkBox-form">
          <AgreePolicy
            name={i18n.l('AgreeTermofService')}
            register={register}
            field="agreeTerms"
            url="https://www.gameloop.com/en/termsOfServices"
          />
          <AgreePolicy
            name={i18n.l('AgreePrivacyPolicy')}
            register={register}
            field="agreePrivacy"
            url={getClientType() === 'Store' ? 'https://store.gameloop.com/PrivacyPolicy.html' : 'https://www.gameloop.com/en/privacypolicy'}
          />
        </form>
      </div>
    </div>
  );
};
